import apiClient from './apiClient';

export async function searchParties(q) {
  const res = await apiClient.get('/complaints/customers', { params: { q } });
  return res.data.data.items;
}

export async function getPartyDispatches(customerId) {
  const res = await apiClient.get('/complaints/dispatches', { params: { customerId } });
  return res.data.data;
}

export async function createComplaint(payload) {
  const res = await apiClient.post('/complaints', payload);
  return res.data.data;
}

export async function listComplaints(status, problemId, from, to) {
  const params = {};
  if (status) params.status = status;
  if (problemId) params.problemId = problemId;
  if (from) params.from = from;
  if (to) params.to = to;
  const res = await apiClient.get('/complaints', { params });
  return res.data.data.items;
}

export async function getComplaint(id) {
  const res = await apiClient.get(`/complaints/${id}`);
  return res.data.data;
}

export async function setComplaintStatus(id, status, resolutionNote) {
  const res = await apiClient.put(`/complaints/${id}/status`, { status, resolutionNote });
  return res.data.data;
}

export async function listProblems(from, to) {
  const params = {};
  if (from) params.from = from;
  if (to) params.to = to;
  const res = await apiClient.get('/complaints/problems', { params });
  return res.data.data.items;
}

export async function addProblem(name) {
  const res = await apiClient.post('/complaints/problems', { name });
  return res.data.data;
}

export async function telegramTest() {
  const res = await apiClient.post('/complaints/telegram-test');
  return res.data.data;
}
